import { render } from "./BagicTable.vue?vue&type=template&id=4ae3c346&scoped=true"
import script from "./BagicTable.vue?vue&type=script&lang=js"
export * from "./BagicTable.vue?vue&type=script&lang=js"

import "./BagicTable.vue?vue&type=style&index=0&id=4ae3c346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae3c346"]])

export default __exports__